import { useEffect, useState } from "react";

/**
 * Runs an async loader when the widget mounts (and when `deps` change) and exposes { loading, data, error }.
 * Widgets use it to fetch their own data so a widget that is not on the dashboard never costs a request.
 */
export default function useAsync(loader, deps) {
  const [state, setState] = useState({ loading: true, data: null, error: null });
  useEffect(() => {
    let live = true;
    setState((current) => ({ ...current, loading: true, error: null }));
    Promise.resolve()
      .then(loader)
      .then((data) => { if (live) setState({ loading: false, data, error: null }); })
      .catch((error) => { if (live) setState({ loading: false, data: null, error }); });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
}
